import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import ReactSelect, { components } from "react-select";
import { Divider, Input, Modal, notification, Popover, Select, Spin, Tag, Tooltip } from "antd";
import styles from "./CreatePost.module.scss";
import { useTranslation } from "react-i18next";
import useFetch, { CachePolicies } from "use-http";
import ImagePreviewPostContainer from "./CoverPreview/ImagePreviewPostContainer";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import * as FilesAPI from "../../../service/files.service";
import { AppContext } from "src/pages/context/App.context";
import { getUserData } from "src/service/auth.service";
import ButtonCenterCLose from "src/components/shared/button/CloseButton/ButtonCenterClose";
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";
//@ts-ignore
import _, { debounce, filter } from "lodash";
import { checkEmpty } from "src/service/util.service";
// import uploadImageIcon from "src/assets/png/uploadImageIcon.png";
import SvgAlignment from "src/components/icon/SvgAlignment";
import SvgAlignLeftIcon from "src/components/icon/SvgAlignLeftIcon";
import SvgAlignRightIcon from "src/components/icon/SvgAlignRightIcon";
import SvgAlignMergeIcon from "src/components/icon/SvgAlignMergeIcon";
import SvgAlignCenterIcon from "src/components/icon/SvgAlignCenterIcon";
import SvgTagFriend from "src/components/icon/SvgTagFriend";
import SvgRegularIcon from "src/components/icon/SvgRegularIcon";
import SvgBoldIcon from "src/components/icon/SvgBoldIcon";
import SvgItalicIcon from "src/components/icon/SvgItalicIcon";
import SvgUnderlineIcon from "src/components/icon/SvgUnderLineIcon";
import { CommunityContext } from "src/pages/context/Community.context";

import SvgEmptyIcon from "src/components/icon/SvgEmptyIcon";
import { postFeed, publishFeed } from "../../../service/feed.sevice";
import { onChangeSelectFileMain } from "../../../service/files.util";
import SvgFont from "src/components/icon/SvgFont";
import SvgUploadImage from "src/components/icon/SvgUploadImage";
import SvgBackground from "src/components/icon/SvgBackground";
import { useAppSelector } from "src/hooks";
import { profile } from "src/features/profile/profileSlice";
import CenterButton from "../../../components/shared/button/CenterButton";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import makeAnimated from 'react-select/animated';
import { async } from "@firebase/util";
import { AnyIfEmpty } from "react-redux";

type NotificationType = 'success' | 'info' | 'warning' | 'error';

const openNotificationWithIcon = (type: NotificationType, message: string, description: string) => {
    notification[type]({
        message: message,
        description: description,
    });
};

const typeTag = {
    user: "user",
    group: "group",
};

const GroupPrivacyLevel: any = {
    0: "PRIVATE",
    1: "CLOSE",
    2: "OPEN",
};

const CustomTypes = {
    Align: "align",
    Style: "style",
    Background: "background",
    TagFriend: "tagfriend",
};

const CaptionAlignType = {
    Left: "left",
    Center: "center",
    Justify: "justify",
    Right: "right",
};

const CaptionStyleType = {
    Regular: "normal",
    Bold: "bold",
    Italic: "italic",
    Underline: "underline",
};

const CaptionBgList = [
    "#fff",
    "#FAF1D6",
    "#FBEDC9",
    "#FFF57A",
    "#F8DDA9",
    "#FFDF6F",
    "#FFDA58",
    "#FBC1AD",
    "#FDD4C1",
    "#F2CDAF",
    "#FAD4AE",
    "#F9E2CF",
    "#FADEE1",
    "#FFDEE1",
    "#FCD9DD",
    "#fdcfe0",
    "#FCB6D0",
    "#EAABBC",
    "#AE8FDC",
    "#D395E0",
    "#DAB3DA",
    "#cfd3fb",
    "#D9F1F1",
    "#CFE7EA",
    "#B6DEE7",
    "#B6E3E9",
    "#A8D4E0",
    "#86DDF3",
    "#71BBEE",
    "#55A6CB",
    "#7DABD0",
    "#96BDC4",
    "#81D290",
    "#AFDE8B",
    "#B6DCB6",
    "#D2E9E1",
    "#E5E1E0",
    "#d2d2d2",
    "#B5AFBC",
];

type CreatePostModalProps = {
    show: boolean,
    group?: any,
    context: any,
    params?: any
    // feedsContext: any
    onClose: any
    onRefresh: any
}

const CreatePostModal = (props: CreatePostModalProps) => {
    const { t } = useTranslation();
    const { group } = props;
    // console.log("grouops", group);

    const postCtx: any = props.context;
    // const group = props?.context?.groupData;
    // const feedsCtx: any = props.feedsContext;
    const appCtx: any = useContext(AppContext);
    const communityCtx: any = useContext(CommunityContext);

    const myProfile = useAppSelector<any>(profile)
    const [categoryOption, setCategoryOption] = useState<any>([]);
    const [tagOption, setTagOption] = useState<any>([]);
    const [customType, setCustomType] = useState(CustomTypes.Align);
    const [captionAlign, setCaptionAlign] = useState(CaptionAlignType.Left);
    const [captionStyle, setCaptionStyle] = useState(CaptionStyleType.Regular);
    const [captionItalic, setCaptionItalic]: any = useState(null);
    const [captionUnderline, setCaptionUnderline] = useState<any>(null);
    const [captionBgColor, setCaptionBgColor] = useState<any>(null);
    const [captionInputStyle, setCaptionInputStyle] = useState({});
    const [categorySearch, setCategorySearch] = useState<any>("");
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const [maxSizeFile, setMaxSizeFile] = useState<number>(100);//mb
    const [cancelPost, setCancelPost] = useState<boolean>(false);
    const [isEditPost, setIsEditPost] = useState<boolean>(false);
    const [allPrivacyValue, setallPrivacyValue] = useState<any>("friends")
    const inputFileToUploadEl = useRef<any>();
    // console.log("communityCtx.members", communityCtx.members);
    const [selectTag, setSelectTag] = useState<any>([]);
    const [options, setOptions] = useState<any>([])
    const [saveTagActive, setSaveTagActive] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState("");
    const [open, setOpen] = useState(false);


    const queryClient = useQueryClient();
    const animatedComponents = makeAnimated();

    const feedMutation = useMutation(publishFeed, {
        onMutate: (variables) => {
            // console.log("onMutate", variables);
        },
        onSuccess: (data, variables, context) => {
            // console.log("onSuccess", data, variables, context);
            // queryClient.setQueryData(['feeds'], (old: any) => {
            //     // // console.log("old", old)
            //     // // let a = [23, 45, 12, 67];
            //     // let newData = old
            //     // let newPage = old.pages
            //     // newPage[0] = newPage[0].feeds.unshift(data);
            //     // newData.pages = newPage
            //     // // console.log("old", old)
            //     // // old.pages.push(data)
            //     // return newData
            //     old.pages.unshift({ feeds: [data], total: 1, offset: 1 })
            //     old.pageParams.unshift(undefined)
            //     console.log("odl", old)
            //     return old
            // })
            onSuccess()
        },
        onError: (error, variables, context) => {
            // console.log("onError");
            onError()
        },
        onSettled: (data, error, newPost) => {
            queryClient.refetchQueries(['feeds', props.params])
        },
    })
    // console.log("tagactive", tagActive);

    // useEffect(()=>{
    //   console.log("postCtx: ", postCtx);

    // },[postCtx])

    const fileServiceDownloadURL =
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";

    const antIcon = (
        <LoadingOutlined style={{ fontSize: 24, color: "#FFFFFF" }} spin />
    );

    const CustomSelectControl = ({ children, ...props }: any) => {
        // const { emoji, onEmojiClick } = props.selectProps;
        const style = { cursor: "pointer" };

        return (
            <components.Control {...props}>
                {group && <span style={style}>{group.name}</span>}
                {children}
            </components.Control>
        );
    };

    const selectCustomStyle = {
        container: (base: any) => ({
            ...base,
            // height: "40px",
        }),
        input: (base: any) => ({
            ...base,
            height: "40px",
            display: "flex",
            alignItems: "center",
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            display: "none",
        }),

        dropdownIndicator: () => ({
            display: "none",
        }),
        control: (base: any, state: any) => {
            return {
                ...base,
                border: state?.isSelected
                    ? "1px solid transparent !important"
                    : "1px solid transparent !important",
                borderColor: state?.isFocused
                    ? "transparent !important"
                    : "transparent !important",
                boxShadow: "none",
            };
        },
        menuList: (base: any) => ({
            ...base,
            "::-webkit-scrollbar-thumb": {
                background: "#bbbfca",
                borderRadius: "10px",
            },
            "::-webkit-scrollbar": {
                background: "transparent",
                width: "10px",
            },
        }),

        valueContainer: (base: any) => ({
            ...base,
            height: "50px",
            "::-webkit-scrollbar": {
                background: "transparent",
                width: "10px",
            },
            // overflow: "auto",
        }),
    };

    const selectCustomStyleCategory = {
        container: (base: any) => ({
            ...base,
            height: "40px",
            width: "100%",
        }),
        input: (base: any) => ({
            ...base,
            height: "50px",
            display: "flex",
            alignItems: "center",
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            display: "none!important",
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            display: "none",
        }),
        control: (base: any, state: any) => {
            return {
                ...base,
                // borderRadius: "30px",
                height: "40px",
                // border: state?.isSelected
                //     ? "1px solid !important"
                //     : "1px solid  !important",
                // borderColor: state?.isFocused
                //     ? "transparent !important"
                //     : "transparent !important",
                boxShadow: "none",
                border: "none",
                // left: "10px",
                borderBottom: "1px solid #BEBEBE !important",
            };
        },

        placeholder: (base: any) => ({
            ...base,
            top: "75%",
        }),
        valueContainer: (base: any) => ({
            ...base,
            height: "40px",
            overflow: "auto",
        }),
    };

    const CustomOption = (props: any) => {
        const { children, data } = props;
        const isGroup = data?.type === "group";
        return (
            <components.Option {...props}>
                <div style={{ display: "inline-flex" }}>
                    <div
                        className={styles.imgOption}
                        style={{
                            backgroundImage: `url(${data?.img})`,
                            borderRadius: isGroup ? 5 : 0,
                            marginRight: 10,
                        }}
                    />
                    {children}
                </div>
            </components.Option>
        );
    };

    const allPrivacyOption = [
        {
            value: "friends",
            label: t("Only friends"),
        },
        {
            value: "tag",
            label: t("Only with tag"),
        },
        {
            value: "public",
            label: t("Public"),
        },
        // {
        //     value: "draft",
        //     label: t("Save Draft"),
        // },
    ];

    const groupPrivacyOption = [
        // {
        //     value: "public",
        //     label: t("Public"),
        // },
        {
            value: "tag",
            label: t("Only with tag"),
        },
        // {
        //     value: "draft",
        //     label: t("Save Draft"),
        // },
    ];

    const apiPost = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/feeds/", {
        cachePolicy: CachePolicies.NO_CACHE,
    });

    const apiEditPost = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/feeds/update/${postCtx.postID}`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiUploadFile = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + `/uploadFile`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiCategory = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/categories/",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiFriends = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/friends",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiMyGroups = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v2/groups/",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiCreateCategory = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/categories/",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiConfigMaxSizeFileMb = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/config/get-config?key=POST_FILE_SIZE",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const handleChangeTitle = (event: any) => {
        postCtx.setTitle(event.target.value);
    };

    const handleChangeContent = (event: any) => {
        postCtx.setContent(event.target.value);
    };

    const handleChangeTag = (tags: any) => {
        postCtx.setIsDisablePostBtn(false);
        postCtx.setTag(tags);
    };

    const handleChangeCategory = (categories: any) => {
        postCtx.setCategory(categories);
    };

    const handleChangePrivacy = (privacy: any, option: any) => {
        console.log("privacy", privacy);
        setallPrivacyValue(privacy)
        postCtx.setPrivacyOption(option);
    };

    const handleInputCatChange = (value: any) => {
        if (value.trim() !== "") {
            setCategorySearch(value);
        }
    };

    const handleClickAddCategory = () => {
        if (categorySearch?.trim() === "") return;

        const createdCat = categoryOption?.find((category: any) => {
            return category?.label === categorySearch;
        });

        if (createdCat) {
            postCtx.setCategory((prev: any) => {
                if (prev == null) return [createdCat];

                return [...prev, createdCat];
            });
            return;
        }

        setCategoryOption((prev: any) => {
            return [
                ...prev,
                {
                    label: categorySearch,
                    name: categorySearch,
                    value: categorySearch,
                },
            ];
        });
        console.log("add category: " + categorySearch);

        postCtx.setCategory((prev: any) => {
            if (prev == null) {
                return [
                    {
                        label: categorySearch,
                        name: categorySearch,
                        value: categorySearch,
                    },
                ];
            }

            return [
                ...prev,
                {
                    label: categorySearch,
                    name: categorySearch,
                    value: categorySearch,
                },
            ];
        });

        setCategorySearch("");
    };

    const resetCreatePost = () => {
        // console.log("resetCreatePost");
        // postCtx.setOldData(null);
        // postCtx.setOldcover(null);
        // postCtx.setPostID(null);
        // postCtx.setIsEditPost(false);
        postCtx.setTitle("");
        postCtx.setContent("");
        postCtx.setIsEditPost(false);
        postCtx.setFileValue(null);
        postCtx.setPreviewCovers(null);
        postCtx.setFileCovers([]);
        postCtx.setTag([]);
        postCtx.setCategory([]);
        postCtx.setPrivacyOption(
            group ? groupPrivacyOption[0] : allPrivacyOption[0]
        );
        setCustomType(CustomTypes.Align);
        setCaptionAlign(CaptionAlignType.Left);
        setCaptionStyle(CaptionStyleType.Regular);
        setCaptionItalic(null);
        setCaptionUnderline(null);
        setCaptionBgColor(null);
        setCaptionInputStyle({});
        setSelectTag([]);
        setallPrivacyValue('friends');
        initResource();
    };

    const getTagsList = (tags: any) => {
        const tagList: any = [];
        let listDeleteSelectTag: any = [];

        if (group) {
            if (postCtx.isEditPost) {
                tagList.push({
                    mentionID: group.id,
                    type: typeTag.group,
                    id: postCtx?.oldData?.groupMention?.id,
                });
            } else {
                tagList.push({
                    mentionID: group.id,
                    type: typeTag.group,
                });
            }
        }

        if (postCtx.isEditPost) {
            if (tags !== null) {
                tags.forEach((item: any) => {
                    const sameOldMention = postCtx?.oldData?.mentions.find(
                        (oldMention: any) => {
                            return item?.mentionID === oldMention?.mentionID;
                        }
                    );

                    if (sameOldMention) {
                        tagList.push({
                            mentionID: item?.mentionID,
                            type: item?.type,
                            id: sameOldMention?.id,
                        });
                    } else {
                        tagList.push({
                            mentionID: item?.mentionID,
                            type: item?.type,
                        });
                    }
                });
            }

            if (postCtx?.oldData?.mentions !== null) {
                postCtx?.oldData?.mentions?.forEach((oldMention: any) => {
                    if (
                        !tagList?.some(
                            (selectTag: any) => selectTag?.mentionID === oldMention?.mentionID
                        )
                    ) {
                        listDeleteSelectTag.push({
                            mentionID: oldMention?.mentionID,
                            type: oldMention?.type,
                            id: oldMention?.id,
                            action: "delete",
                            feedID: postCtx.postID,
                            user: oldMention.user,
                        });
                    }
                });
            }
        } else {
            if (tags !== null) {
                tags.forEach((item: any) => {
                    tagList.push({
                        mentionID: item?.mentionID,
                        type: item?.type,
                    });
                });
            }
        }

        return [...tagList, ...listDeleteSelectTag];
    };

    const getCategoryList = async (categories: any) => {
        const catList: any = [];
        const catDeleteList: any = [];

        if (postCtx?.isEditPost) {
            if (categories) {
                for (let item of categories) {
                    const sameOldcategory = postCtx?.oldData?.categories.find(
                        (oldCategory: any) => {
                            return item?.categoryID === oldCategory?.categoryID;
                        }
                    );

                    if (!item?.categoryID) {
                        try {
                            const res = await apiCreateCategory.post({ name: item?.name });
                            if (apiCreateCategory.response.ok) {
                                catList.push({ categoryID: res?.id });
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    }

                    if (sameOldcategory) {
                        catList.push({
                            id: sameOldcategory?.id,
                            categoryID: sameOldcategory?.categoryID,
                        });
                    } else {
                        catList.push({
                            categoryID: item?.categoryID,
                        });
                    }
                }
            }

            if (postCtx?.oldData?.categories) {
                postCtx?.oldData?.categories?.forEach((oldCategory: any) => {
                    if (
                        !catList?.some(
                            (selectTag: any) =>
                                selectTag?.categoryID === oldCategory?.categoryID
                        )
                    ) {
                        catDeleteList.push({
                            action: "delete",
                            categotyID: oldCategory?.categoryID,
                            id: oldCategory?.id,
                        });
                    }
                });
            }
        } else {
            if (categories) {
                for (let category of categories) {
                    if (category?.categoryID) {
                        catList.push({ categoryID: category.categoryID });
                    } else {
                        try {
                            const res = await apiCreateCategory.post({
                                name: category?.name,
                            });
                            if (apiCreateCategory.response.ok) {
                                console.log(`created category: `, res?.name);

                                catList.push({ categoryID: res?.id });
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }
            }
        }

        return [...catList, ...catDeleteList];
    };

    // const getFile = async (item: any, url: any) => {
    //   console.log("item : ", item);
    //   url = await FilesAPI.getUrl(url, item?.imageID, 300, "post");
    //   return url;
    // };

    const onChangeSelectFile = async (event: any) => {
        await onChangeSelectFileMain(event, postCtx, inputFileToUploadEl);
    };

    const getCoversList = (newCovers: any) => {
        const coversArr: any = [];
        const coversDeleteArr: any = [];

        console.log("newCovers.length", newCovers.length);
        if (postCtx.isEditPost) {
            const oldCovers =
                postCtx.previewCovers !== null
                    ? postCtx.previewCovers.filter((cover: any) => {
                        return cover.imageID;
                    })
                    : [];

            if (oldCovers.length > 0) {
                oldCovers.forEach((item: any) => {
                    coversArr.push({
                        id: item?.id,
                        imageID: item?.imageID,
                        feedId: postCtx.postID,
                        coverLink: item?.coverLink,
                        coverKind: item?.coverKind,
                    });
                });
            }

            if (newCovers.length > 0) {
                newCovers.forEach(async (item: any) => {
                    let url: any = fileServiceDownloadURL + item?.imageID + "&size=1024";
                    url = await FilesAPI.getUrl(url, item?.imageID, 1024, "post");

                    coversArr.push({
                        imageID: item?.imageID,
                        feedId: postCtx.postID,
                        coverLink: url,
                        coverKind: item?.coverKind,
                    });
                });
            }

            if (postCtx?.oldcover?.covers !== null) {
                console.log("coversArr=>", coversArr);
                // console.log('oldData',postCtx?.oldData);
                console.log("oldcover-->", postCtx?.oldcover);

                for (const oldCover of postCtx?.oldcover) {
                    if (
                        !coversArr?.some(
                            (cover: any) => cover?.imageID === oldCover?.imageID
                        )
                    ) {
                        coversDeleteArr.push({
                            action: "delete",
                            id: oldCover?.id,
                            imageID: oldCover?.imageID,
                            feedId: postCtx.postID,
                            coverLink: oldCover?.coverLink,
                            coverKind: oldCover?.coverKind,
                        });
                    }
                }
            }
        } else {
            if (newCovers !== null) {
                newCovers.forEach((cover: any) => coversArr.push(cover));
            }
        }
        console.log("coversDeleteArr", coversDeleteArr);

        return [...coversArr, ...coversDeleteArr];
    };

    const uploadImage = async () => {
        const listResponseUpload: any = [];
        console.log(":: postCtx.fileCovers", postCtx.fileCovers);
        const items = Object.assign([], postCtx.fileCovers);
        console.log("items", items)
        try {
            for (let item of items) {
                console.log("::>> item", item);

                const responseData = await apiUploadFile.post(item?.fileData);
                console.log("::>> responseData", responseData);

                if (responseData?.success) {
                    let responseUpload = {
                        imageID: responseData.data.id,
                        title: responseData.data.fileName,
                        coverKind: item?.fileType?.includes("video") ? "video" : "image",
                    };


                    listResponseUpload.push(responseUpload);
                }


            }
            console.log(":: listResponseUpload", listResponseUpload);
        } catch (error) {
            console.error("Error UploadFile : ", error);
            return [];
        }
        return listResponseUpload;
    };

    const onSuccess = () => {
        // postCtx.setOldData(null);
        // postCtx.setOldcover(null);
        // postCtx.setPostID(null);
        // postCtx.setIsEditPost(false);
        openNotificationWithIcon('success', t("You have successfully posted"), t(""));
        appCtx.setEnableBeforeUnload(false);
        resetCreatePost();
    }

    const onError = () => {
        openNotificationWithIcon('error', t("Post error"), t("post not success"));
        appCtx.setEnableBeforeUnload(false);
        resetCreatePost();
    }

    const onPost = async (value: string) => {
        const categoryList = await getCategoryList(postCtx.category);
        const styleContent = {
            textAlign: captionAlign,
            backgroundColor: captionBgColor,
            textDecoration: captionUnderline,
            fontWeight: captionStyle,
            fontStyle: captionItalic,
        };
        feedMutation.mutate({
            user: postCtx.user,
            userId: getUserData().id,
            postId: postCtx?.postID,
            title: postCtx.title,
            content: postCtx.content,
            privacy: value ? value : postCtx.privacyOption.value,
            mentions: getTagsList(postCtx.tag),
            feedKind: "post",
            groupId: postCtx?.group?.id,
            isEditPost: postCtx?.isEditPost,
            fileCovers: postCtx.fileCovers,
            fileToUpload: postCtx.fileToUpload,
            tagList: getTagsList(postCtx.tag),
            categoryList: categoryList,
            styleContent: styleContent,
            previewCovers: postCtx.previewCovers,
            oldcover: postCtx?.oldcover,
            feedContext: postCtx,

        })
        // () => {
        //     onSuccess();
        // },
        // () => {
        //     onError();
        // },
        //     () => {
        //         props?.onRefresh();
        //     }
        // await postFeed(
        //     postCtx.user,
        //     getUserData().id,
        //     postCtx?.postID,
        //     postCtx.title,
        //     postCtx.content,
        //     value ? value : postCtx.privacyOption.value,
        //     // categoryList,
        //     getTagsList(postCtx.tag),
        //     "post",
        //     postCtx?.group?.id,
        //     postCtx?.isEditPost,
        //     postCtx.fileCovers,
        //     postCtx.fileToUpload,
        //     getTagsList(postCtx.tag),
        //     categoryList,
        //     styleContent,
        //     postCtx.previewCovers,
        //     postCtx?.oldcover,
        //     postCtx,
        //     () => {
        //         onSuccess();
        //     },
        //     () => {
        //         onError();
        //     },
        //     () => {
        //         props?.onRefresh();
        //     },
        // )
        postCtx.setOldData(null);
        postCtx.setOldcover(null);
        postCtx.setPostID(null);
        postCtx.setIsEditPost(false);
        resetCreatePost();
    }

    const handleClickPostBtn = async () => {
        console.log("handleClickPostBtn");
        const fileSize = postCtx.fileCovers?.length ? postCtx.fileCovers?.length : 0;
        const tagList = getTagsList(postCtx.tag);
        const categoryList = await getCategoryList(postCtx.category);
        const covers = await uploadImage();
        const coversArrObj = getCoversList(covers);
        const styleContent = {
            textAlign: captionAlign,
            backgroundColor: captionBgColor,
            textDecoration: captionUnderline,
            fontWeight: captionStyle,
            fontStyle: captionItalic,
        };
        console.log("covers => ", covers);
        console.log("รูปที่จะลง db => ", coversArrObj);

        if (fileSize !== covers.length) {
            openNotificationWithIcon('error', t("Post error"), t("post not success."));
            return;
        }

        if (postCtx.isEditPost) {
            // const Arrcovers: any = [] ;
            coversArrObj.push(...covers);
            // for (const item of coversArrObj) {
            //   if (item?.action !== "delete") {
            //     Arrcovers.push(item);
            //   }
            // }
            // console.log(Arrcovers);
            // coversArrObj = Object.assign(Arrcovers);
            // console.log(coversArrObj);
        }

        let postData = {
            type: "post",
            title: postCtx.title,
            content: postCtx.content,
            userID: getUserData().id,
            privacy: postCtx.privacyOption.value,
            covers: coversArrObj,
            categories: categoryList,
            mentions: tagList,
            feedKind: "post",
            groupID: postCtx?.group?.id,
            styleContent: JSON.stringify(styleContent),

        };


        let res: any;
        if (postCtx.isEditPost) {
            console.log("postData1", postData);
            res = await apiEditPost.put(postData);
            console.log("res1", res);
            props.onRefresh();
        } else {
            console.log("postData2", postData);
            res = await apiPost.post(postData);
            console.log("res2", res);
            res = Object.assign(res, {
                user: postCtx.user,
            });

            if (res.privacy !== "draft") {
                postCtx.setFeeds((prev: any) => {
                    const feedList: any = [...prev.feeds];
                    feedList.push(res);
                    feedList.sort((a: any, b: any) => {
                        if (a.createdAt > b.createdAt) return -1;
                        if (a.createdAt < b.createdAt) return 1;
                    });

                    const newFeedsObj = {
                        feeds: feedList,
                        offset: prev.offset,
                        total: prev.total,
                    };

                    return newFeedsObj;
                });
                props.onRefresh();
            }
        }

        postCtx.setOldData(null);
        postCtx.setOldcover(null);
        postCtx.setPostID(null);
        postCtx.setIsEditPost(false);
        openNotificationWithIcon('success', t("You have successfully posted"), t(""));
        appCtx.setEnableBeforeUnload(false);
        resetCreatePost();
    };

    const sortFeeds = (feeds: any) => {
        return feeds.sort((a: any, b: any) => {
            if (a.createdAt > b.createdAt) return -1;
            if (a.createdAt < b.createdAt) return 1;
        });
    };

    useEffect(() => {
        postCtx.setUserId(getUserData()?.id);
    }, [])
    useEffect(() => {
        if (
            !_.isEmpty(postCtx.title) ||
            !_.isEmpty(postCtx.content) ||
            !_.isEmpty(postCtx.previewCovers)
        ) {
            postCtx.setIsDisablePostBtn(false);
            // console.log(postCtx.isDisablePostBtn)
        } else {
            postCtx.setIsDisablePostBtn(true);
            // console.log(postCtx.isDisablePostBtn)
        }
    }, [postCtx.title, postCtx.previewCovers, postCtx.content]);

    const setPreviewCovers = (previewCovers: any) => {
        console.log("previewCovers", previewCovers);
        const covers: any = new Array();
        for (let index = 0; index < previewCovers.length; index++) {
            let cover: any = {
                coverLink: previewCovers[index].url,
                coverType: previewCovers[index].type,
                rotation: previewCovers[index].rotation,
                title: previewCovers[index].title,
            };
            covers.push(cover);
        }
        if (_.isEmpty(postCtx.previewCovers)) {
            postCtx.setPreviewCovers(covers);
            showModal();
        } else {
            postCtx.setPreviewCovers((prevCovers: any) => [...prevCovers, ...covers]);
        }
    };
    const setFileCoversData = (fileCovers: any) => {
        if (postCtx.fileCovers === null) {
            postCtx.setFileCovers(fileCovers);
        } else {
            postCtx.setFileCovers((prevFileCovers: any) => [
                ...prevFileCovers,
                ...fileCovers,
            ]);
        }
    };

    const checkRotation = async (url: string) => {
        const img = new Image();
        img.src = url;
        await img.decode();

        const rotation = {
            horizontal: "horizontal",
            vertical: "vertical",
            default: "default",
        };

        if (img.width > img.height) {
            return img.height < img.width * 0.75
                ? rotation.horizontal
                : rotation.default;
        } else if (img.height > img.width) {
            return img.width < img.height * 0.75
                ? rotation.vertical
                : rotation.default;
        } else {
            return rotation.default;
        }
    };

    const handleUploadImage = async (event: any) => {
        let previewCovers = new Array();
        let fileCovers = new Array();

        for (let index = 0; index < event?.target?.files?.length; index++) {
            const { files } = event?.target;
            const file = files?.[index];

            if (
                file &&
                (file.type.startsWith("image/") || file.type.startsWith("video/"))
                && (file?.size / 1024 / 1024) <= maxSizeFile
            ) {
                console.log(file.type);

                let groupID = "";
                if (!checkEmpty(group?.id)) {
                    groupID = group.id;
                }

                const data = new FormData();
                data.append("file", file);
                data.append("fullName", file?.name);
                data.append("fileName", file?.name?.split(".")[0]);
                data.append("fileType", file?.name?.split(".")[1]);
                data.append("size", file?.size);
                data.append("userId", myProfile.id);
                data.append("parent_folder_id", "");
                data.append("actionType", "post");
                data.append("groupId", groupID);
                fileCovers.push({
                    fileData: data,
                    fileType: file.type.startsWith("image/") ? "image" : "video",
                });

                const url = URL.createObjectURL(file);
                let previewCover = {
                    url: url,
                    type: file.type.startsWith("image/") ? "image" : "video",
                    title: file.name,
                };

                previewCovers.push(previewCover);
            } else {
                if (!file.type.startsWith("image/") && !file.type.startsWith("video/")) {
                    notification["warning"]({
                        message: t("Please select only image or video files")
                    });
                    return;
                }

                if ((file?.size / 1024 / 1024) <= maxSizeFile) {
                    notification["error"]({
                        message: t("The file is too large."),
                        description: t("Please select file less than ") + maxSizeFile + "MB.",
                    });
                } else {
                    notification["warning"]({
                        message: t("Upload file error."),
                        description:
                            t("Can not use this file") +
                            ", " +
                            t("please select another file") +
                            ".",
                    });
                }
            }
        }

        const fullPreviewCovers = await Promise.all(
            previewCovers.map(async (cover: any) => {
                const rotation =
                    cover.type === "image" ? await checkRotation(cover.url) : "default";
                const newCover = Object.assign({ rotation: rotation }, cover);
                return newCover;
            })
        );

        setPreviewCovers(fullPreviewCovers);
        setFileCoversData(fileCovers);
    };

    const showModal = () => {
        postCtx.setShowModalCreatePost(true);
    };
    const handleSaveDraft = () => {
        // postCtx.setPrivacyOption("draft");
        handleOk("draft")
    }
    const handleSaveTags = () => {
        console.log("valueoptionsave", selectTag);
        if (selectTag) {
            postCtx.setTag(selectTag)
            setOpen(false);
        }
        setCustomType("")
        setSelectedItem("");
    }

    const handlePost = () => {
        // console.log("postctx", postCtx.privacyOption);
        // postCtx.setPrivacyOption("draft");
        handleOk(allPrivacyValue)
    }
    const handleOk = async (value: string = "") => {
        console.log("Posting..", value);
        if (!postCtx.confirmLoading || !isPosting) {
            postCtx.setConfirmLoading(true);
            setIsPosting(true);
            // appCtx.setLoadingOverlay(true);
            // appCtx.setOverlayText(t("Posting.."));
            appCtx.setEnableBeforeUnload(true);
            await onPost(value);
        }

        setTimeout(() => {
            postCtx.setConfirmLoading(false);
            props.onClose();
            // postCtx.setShowModalCreatePost(false);
            setIsPosting(false);
            // appCtx.setLoadingOverlay(false);
            // appCtx.setEnableBeforeUnload(false);
            // appCtx.setOverlayText("");
        }, 500);
        resetCreatePost();
    };
    const handleCancel = () => {
        console.log("Clicked cancel button");
        if (postCtx.isDisablePostBtn) {
            props.onClose();
            // postCtx.setShowModalCreatePost(false);
            resetCreatePost();
        } else {
            if (isPosting) {
                props.onClose();
                // postCtx.setShowModalCreatePost(false);
                openNotificationWithIcon('info', t("Processing"), t("We will notify you when posting is complete.."));
                resetCreatePost();
                return;
            }
            showModalCheckCancel();
        }
    };

    const handleCloseCover = (coverLink: number) => {
        console.log("coverLink : ", coverLink);
        const covers = _.remove(
            postCtx.previewCovers,
            function (cover: any, indexCover: number) {
                console.log("coverLink2: ", cover.coverLink);
                if (cover.coverLink === coverLink) {
                    console.log("fileCovers.length", postCtx.fileCovers.length);
                    const fileCovers = _.remove(
                        postCtx.fileCovers,
                        function (file: any, indexFile: number) {
                            console.log(":: File>>", file);
                            console.log(":: indexFile>>", indexFile);
                            if (indexFile === indexCover) return false;
                            else return true
                        }
                    );
                    postCtx.setFileCovers(fileCovers);
                    return false;
                } else return true
            }
        );
        // console.log("cover SplitcoverLink ", SplitcoverLink);
        console.log("cover ls ", covers);
        // postCtx.setPreviewCovers(Object.assign([], []));
        postCtx.setPreviewCovers(Object.assign([], covers));

        // setTimeout(() => {
        //   postCtx.setPreviewCovers(Object.assign([], covers));
        // }, 1);
    };

    const showModalCheckCancel = () => {
        setCancelPost(true);
        postCtx.setShowModalCheckCancel(true);
    };
    const okModalCheckCancel = () => {
        postCtx.setShowModalCheckCancel(false);
        // postCtx.setShowModalCreatePost(false);
        props.onClose();
        resetCreatePost();
    };
    const hideModalCheckCancel = () => {
        postCtx.setShowModalCheckCancel(false);
    };

    const openLive = () => {
        console.log("openLive");
        window.open("/live", "_blank");
    };
    const Alignitem = (
        <div className={styles.customOptions}>
            <>
                <div
                    className={styles.customItem}
                    onClick={() => setCaptionAlign(CaptionAlignType.Left)}
                >
                    <SvgAlignLeftIcon
                        style={
                            captionAlign === CaptionAlignType.Left
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
                <div
                    className={styles.customItem}
                    onClick={() => setCaptionAlign(CaptionAlignType.Center)}
                >
                    <SvgAlignCenterIcon
                        style={
                            captionAlign === CaptionAlignType.Center
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
                <div
                    className={styles.customItem}
                    onClick={() => setCaptionAlign(CaptionAlignType.Justify)}
                >
                    <SvgAlignMergeIcon
                        style={
                            captionAlign === CaptionAlignType.Justify
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
                <div
                    className={styles.customItem}
                    onClick={() => setCaptionAlign(CaptionAlignType.Right)}
                >
                    <SvgAlignRightIcon
                        style={
                            captionAlign === CaptionAlignType.Right
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
            </>
        </div>
    )
    const styleFont = (
        <div className={styles.customOptions}>
            <>
                <div
                    className={styles.customItem}
                    onClick={() => setCaptionStyle(CaptionStyleType.Regular)}
                >
                    <SvgRegularIcon
                        style={
                            captionStyle === CaptionStyleType.Regular
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
                <div
                    className={styles.customItem}
                    onClick={() => setCaptionStyle(CaptionStyleType.Bold)}
                >
                    <SvgBoldIcon
                        style={
                            captionStyle === CaptionStyleType.Bold
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
                <div
                    className={styles.customItem}
                    onClick={handleCaptionItalicChange}
                >
                    <SvgItalicIcon
                        style={
                            captionItalic === CaptionStyleType.Italic
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
                <div
                    className={styles.customItem}
                    onClick={handleCaptionUnderlineChange}
                >
                    <SvgUnderlineIcon
                        style={
                            captionUnderline === CaptionStyleType.Underline
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                    />
                </div>
            </>
        </div>

    )
    const backgroundCaption = (
        <div className={styles.customOptions} style={{ width: 470, }}>
            <>
                <div
                    className={styles.customItem}
                    onClick={() => {
                        setCaptionBgColor("#fff");
                    }}
                >
                    <SvgEmptyIcon
                        style={
                            captionBgColor === "#fff"
                                ? { fill: "#000" }
                                : { fill: "#bebebe" }
                        }
                        width={"20px"}
                    />
                </div>
                {CaptionBgList.map((bgColor: any) => {
                    if (bgColor !== "#fff") {
                        return (
                            <div
                                key={bgColor}
                                className={
                                    captionBgColor === bgColor
                                        ? styles.colorItemActive
                                        : styles.colorItem
                                }
                                style={{ backgroundColor: bgColor }}
                                onClick={() => {
                                    setCaptionBgColor(bgColor);
                                }}
                            ></div>
                        );
                    }
                })}
            </>
        </div>
    )

    const showList = (
        <div className={styles.leftSection}>
            {tagOption?.map((tagOpt: any, idx: number) => {
                return (
                    <div style={{ width: "100%" }}>{t(tagOpt?.label)}
                        {tagOpt?.options?.map((item: any, key: any) => {
                            return (
                                <div style={{ display: "flex", margin: "20px 0px" }}>
                                    <div
                                        className={styles.profileImage}
                                        key={key}
                                        style={{ backgroundImage: `url(${item?.img})` }}
                                    />
                                    <div className={styles.memberDetail}>
                                        <Tooltip
                                            placement={"topLeft"}
                                            // placement={props?.community ? "topLeft" : "top"}
                                            title={item.label}
                                            color="#0f4c82"
                                        >
                                            <div className={styles.memberName}>
                                                {item.label}
                                            </div>
                                        </Tooltip>
                                        <div className={styles.mutualGroup}>
                                            {(tagOpt?.label !== "Groups") ? item.username : null}
                                        </div>
                                    </div>
                                    <CenterButton
                                        onClick={() => handleAddTag(item, key)}
                                        key={key}
                                        disabled={item.addTag}

                                    >
                                        <div>
                                            {postCtx.confirmLoading || isPosting ? (
                                                <Spin indicator={antIcon} />
                                            ) : (
                                                t("Add")
                                            )}
                                        </div>
                                    </CenterButton>
                                </div>
                            )
                        }
                        )}
                    </div>
                )
            })}
        </div>
    )

    const tagRender = (props: any) => {
        // console.log("props", props);
        const { label, value, closable, onClose } = props;
        return (
            <Tag
                color='blue'
                // onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                // closable={() => {
                //     deleteTags(props)
                // }}
                style={{
                    marginRight: 3
                }}
            >
                {label}
            </Tag>
        );

    };
    const deleteTags = (data: any) => {
        const tagsnew = selectTag?.filter((item: any) => {
            if (item.value === data)
                item.addTag = false
            return item.value !== data
        })
        setSelectTag(tagsnew);
    }

    const handleAddTag = (item: any, key: any) => {
        item.addTag = true
        setSelectTag((prev: any) => {
            return [...prev, item]
        });
    }
    const getMemberName = (data: any) => {
        let allMember =
            data?.privacyLevel >= 3
                ? _.filter(data?.members, (member) => {
                    if (member?.user) {
                        return member?.user?.id !== getUserData().id;
                    }
                })
                : data?.members;
        let members = Object.assign([], _.slice(allMember, 0, 4));
        if (!members?.[0]) return null;
        let memberName: any = [];
        _.each(members, (item: any) => {
            if (item?.user?.id !== getUserData().id) {
                const username = item?.user?.firstname
                    ? item?.user?.firstname + " " + (item?.user?.lastname || "")
                    : item?.user?.id;
                memberName.push(username);
            }
        });
        return memberName.join(" ,");
    };

    const loadCategoryOption = (categories: any) => {
        let catNames: any = [];
        let catList: any = [];
        categories.forEach((category: any) => {
            if (catNames.includes(category.name)) return;
            catNames.push(category.name);
            catList.push({
                label: category.name,
                categoryID: category.id,
                name: category.name,
                value: category.name,
            });
        });
        setCategoryOption(catList);
    };

    const loadTagOption = (friends: any, groups: any, members: any) => {
        let listFriend: any = [];
        let listGroup: any = [];
        let listOptions: any = [];
        let listOptionsMembers: any = [];
        let listMembers: any = [];
        let taglist: any = [];

        // GroupMembers
        members?.data?.forEach((data: any) => {
            const tagGroupMembers = selectTag?.filter((tag: any) => {
                return (tag.value === data?.user?.id) && tag.addTag === true
            });
            // console.log("datamembers", data);
            let membersOption = {
                label: data?.user?.firstname
                    ? data?.user?.firstname + " " + (data?.user?.lastname || "")
                    : data?.user?.username,
                mentionID: data?.user?.id,
                type: typeTag.user,
                username: data?.user?.email,
                value: data?.user?.id,
                img: data.user?.imageProfileURL,
                addTag: tagGroupMembers?.length > 0 ? true : false,
            };

            listMembers.push(membersOption);
            let optionMembers = {
                type: typeTag.user,
                mentionID: data?.user?.id,
                label: data?.user?.firstname
                    ? data?.user?.firstname + " " + (data?.user?.lastname || "")
                    : data?.user?.username,
                value: data?.user?.id,
            };
            listOptionsMembers.push(optionMembers);
        });

        // friends
        friends?.data?.forEach((data: any) => {
            const tagFriends = selectTag?.filter((tag: any) => {
                return (tag.value === data?.friend?.id) && tag.addTag === true
            });

            let friendOption = {
                label: data?.friend?.firstname
                    ? data?.friend?.firstname + " " + (data?.friend?.lastname || "")
                    : data?.friend?.username,
                mentionID: data?.friend?.id,
                type: typeTag.user,
                username: data?.friend?.email,
                value: data?.friend?.id,
                img: data.friend?.imageProfileURL,
                addTag: tagFriends?.length > 0 ? true : false,
            };
            listFriend.push(friendOption);
            let optionFriends = {
                type: typeTag.user,
                mentionID: data?.friend?.id,
                label: data?.friend?.firstname
                    ? data?.friend?.firstname + " " + (data?.friend?.lastname || "")
                    : data?.friend?.username,
                value: data?.friend?.id,
            };
            listOptions.push(optionFriends);
        });

        // MyGroups
        groups?.groups?.forEach((data: any) => {
            const tagMyGroups = selectTag?.filter((tag: any) => {
                return tag.value === data?.id && tag.addTag === true
            });

            let groupOption = {
                label:
                    GroupPrivacyLevel[data?.privacyLevel] && data?.name
                        ? data?.name
                        : getMemberName(data),
                mentionID: data?.id,
                type: typeTag.group,
                totalMember: data?.totalMember,
                value: data?.id,
                img: data.coverImgURL,
                addTag: tagMyGroups?.length > 0 ? true : false,
            };
            listGroup.push(groupOption);
            let optionGroup = {
                type: typeTag.group,
                mentionID: data?.id,
                label:
                    GroupPrivacyLevel[data?.privacyLevel] && data?.name
                        ? data?.name
                        : getMemberName(data),
                value: data?.id,
            };
            listOptions.push(optionGroup);
        });

        if (group) {
            taglist = [
                { label: listMembers.length > 0 ? t("Members") : null, options: listMembers }
            ];
            setTagOption(taglist);
            setOptions(listOptionsMembers);
        } else {
            taglist = [
                { label: listFriend.length > 0 ? t("Friends") : null, options: listFriend },
                { label: listGroup.length > 0 ? t("Groups") : null, options: listGroup },
            ];
            setTagOption(taglist);
            setOptions(listOptions);
        }
    };

    const initResource = async () => {
        try {
            let resCategory = await apiCategory.get();
            let resFriends = await apiFriends.get(`?search=${selectedItem}`);
            let resGroups = await apiMyGroups.get(`?search=${selectedItem}`);
            let resMembersGroup;
            if (group) {
                resMembersGroup = await apiMyGroups.get(`/group-members/${group.id}?search=${selectedItem}`);
                console.log("group resMembersGroup>>", resMembersGroup);
            }
            loadTagOption(resFriends, resGroups, resMembersGroup);
            loadCategoryOption(resCategory?.data);
        } catch (error) {
            console.error(error);
        }
    };

    const getMaxSizeFile = async () => {
        let resConfigSizeMb = await apiConfigMaxSizeFileMb.get();
        let maxSizeMb = parseFloat(resConfigSizeMb?.value.toLowerCase().replace("mb", ""))

        if (maxSizeMb > 0)
            setMaxSizeFile(maxSizeMb)
    };

    function handleCaptionItalicChange() {
        setCaptionItalic((pre: any) => {
            if (pre) {
                return null;
            } else {
                return CaptionStyleType.Italic;
            }
        });
    }

    function handleCaptionUnderlineChange() {
        setCaptionUnderline((pre: any) => {
            if (pre) {
                return null;
            } else {
                return CaptionStyleType.Underline;
            }
        });
    }

    const handleChangeCaptionStyle = () => {
        setCaptionInputStyle({
            textAlign: captionAlign,
            backgroundColor: captionBgColor,
            textDecoration: captionUnderline,
            fontWeight: captionStyle,
            fontStyle: captionItalic,
        });
    };
    const handleClickUploadImage = () => {
        document.getElementById("uploadImageEl")!.click();
    };
    const initCaptionStyle = () => {
        const captionStyle = postCtx?.captionStyle;

        if (_.isEmpty(postCtx.fileCovers) && _.isEmpty(postCtx.previewCovers)) {
            setCaptionBgColor(captionStyle?.backgroundColor);
        }

        setCaptionAlign(captionStyle?.textAlign);
        setCaptionUnderline(captionStyle?.textDecoration);
        setCaptionStyle(captionStyle?.fontWeight);
        setCaptionItalic(captionStyle?.fontStyle);
    };

    useEffect(() => {
        handleChangeCaptionStyle();
    }, [
        captionAlign,
        captionBgColor,
        captionUnderline,
        captionStyle,
        captionItalic,
    ]);

    useEffect(() => {
        initCaptionStyle();
    }, [postCtx.captionStyle]);

    useEffect(() => {
        console.log("postCtx.fileToUpload", postCtx.fileToUpload)
    }, [postCtx.fileToUpload])

    useEffect(() => {
        getMaxSizeFile();
        initResource();
        postCtx.setPrivacyOption(
            group ? groupPrivacyOption[0] : allPrivacyOption[0]
        );

        return () => {
            // apiPost.abort();
            // apiUploadFile.abort();
            // apiCategory.abort();
            // apiFriends.abort();
            // apiMyGroups.abort();
            // apiEditPost.abort();
            // apiCreateCategory.abort();
            // apiConfigMaxSizeFileMb.abort();
        };
    }, []);

    const updatedTags = () => {
        if (postCtx.tag) {
            const updatedTags = postCtx.tag.map((tag: any) => ({ ...tag, addTag: true }));
            setSelectTag(updatedTags);
        }
    }

    useEffect(() => {
        if (postCtx.isEditPost) {
            if (postCtx.privacyOption.value !== "draft") {
                setallPrivacyValue(postCtx.privacyOption.value);
            }
        }
    }, [props.show])

    useEffect(() => {
        if (postCtx.isEditPost) {
            updatedTags();
        }
    }, [props.show, open])

    const filteredOptions = useMemo(() => {
        return options.filter((o: any) => selectTag?.findIndex((t: any) => (t.value === o.value)) === -1);
    }, [selectTag, options])

    const showModals = () => {
        setOpen(true);
    };

    const hideModal = () => {
        if (postCtx.isEditPost) {
            updatedTags();
        }
        setSelectTag([]);
        setSelectedItem("");
        setOpen(false);
    };

    const handleChange = (value: any, option: any[]) => {
        if (option[option.length - 1]) {
            let opt: any = [{
                addTag: true,
                type: option[option.length - 1].type,
                mentionID: option[option.length - 1].value,
                label: option[option.length - 1].label,
                value: option[option.length - 1].value
            }]
            option = opt
        }
        // console.log("option ", JSON.stringify(option));
        setSelectTag((prev: any[]) => {
            return [...prev, option[option.length - 1]]
        });
    };
    const handleSearch = (newValue: string) => {
        console.log("handleSearch : ", newValue);
        setSelectedItem(newValue);
    };

    useEffect(() => {
        initResource();
        console.log("selectTag : ", selectTag);
    }, [selectedItem, selectTag])

    return (

        <Fragment>

            <Modal
                centered
                open={props.show}
                className={styles.modalOveride}
                onCancel={() => {
                    handleCancel();
                }}
            >
                <div style={{ position: "absolute", top: 22, right: 22 }}>
                    <ButtonCenterCLose onClick={handleCancel} />
                </div>

                <div className={styles.boxCreate}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <div
                            className={styles.textCreatePost}>{postCtx.isEditPost ? t("Edit post") : t("Create post")}</div>
                    </div>
                </div>

                <div className={styles.postDetailContainer}>
                    <div>
                        <div
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                // justifyContent: "center",
                                marginBottom: 10,
                            }}
                        >
                            <div
                                className={styles.profileImg}
                                style={{
                                    // backgroundImage: `url(${getUserData().imageProfileURL})`,
                                    backgroundImage: `url(${myProfile.imgURL})`,
                                }}
                            ></div>
                            {/* <div className={styles.username}>{getUserData().firstname}</div> */}
                            <div
                                style={{ display: "flex", width: "100%", paddingRight: "35px", flexDirection: "column" }}
                            >
                                <div className={styles.username}>
                                    {myProfile.name}
                                </div>
                                <Select
                                    className={styles.selectCustomStyleCategory}
                                    onChange={handleChangePrivacy}
                                    disabled={group}
                                    value={group ? groupPrivacyOption : allPrivacyValue}
                                    options={group ? groupPrivacyOption : allPrivacyOption}
                                >

                                </Select>
                            </div>
                        </div>

                        <div style={{ width: "100%" }}>
                            {/* <label className={styles.createPostLabel}>{t("Title")}</label> */}
                            <input
                                className={styles.titleInput}
                                type="text"
                                placeholder={t("Add Topic")}
                                onChange={handleChangeTitle}
                                value={postCtx.title}
                            ></input>
                        </div>
                        <Modal
                            centered
                            visible={customType === CustomTypes.TagFriend}
                            className={styles.modalOveride}
                            open={open}
                        >
                            <div style={{ position: "absolute", top: 22, right: 22 }}>
                                <ButtonCenterCLose onClick={() => {
                                    hideModal();
                                }} />
                            </div>
                            <div className={styles.boxCreate}>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <div className={styles.textCreatePost}>{t("Tags")}</div>
                                </div>
                            </div>
                            <div className={styles.tagInput}>
                                <Select
                                    placeholder={t("Tag Friends, Groups or Community")}
                                    mode="multiple"
                                    // tagRender={tagRender}
                                    searchValue={selectedItem}
                                    showSearch={true}
                                    value={selectTag}
                                    className={styles.selectCustomStyle}
                                    onChange={handleChange}
                                    onSearch={handleSearch}
                                    onDeselect={deleteTags}
                                    filterOption={false}
                                    options={filteredOptions}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                />
                            </div>
                            <div className={styles.postDetailContainer} style={{ height: 395 }}>
                                {showList}
                            </div>
                            <Divider style={{ backgroundColor: "#cccccc", margin: "25px 0px" }} />
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <CenterButton
                                    small
                                    loading={postCtx.confirmLoading}
                                    onClick={() => {
                                        handleSaveTags()
                                    }}
                                    disabled={saveTagActive}
                                >
                                    {/* <div>
                                        {postCtx.confirmLoading || isPosting ? (
                                            <Spin indicator={antIcon} />
                                        ) : ( */}
                                    {t("Save")}
                                    {/* )}
                                    </div> */}
                                </CenterButton>
                            </div>
                        </Modal>
                        {/* ) */}
                        {/* })} */}


                        <div style={{ width: "100%", height: "120px", marginBottom: "20px" }}>
                            <textarea
                                rows={5}
                                style={captionInputStyle}
                                className={styles.captionInput}
                                placeholder={t("Add caption")}
                                onChange={handleChangeContent}
                                value={postCtx.content}
                            />
                        </div>
                        <div style={{ position: "relative" }}>
                            {_.isEmpty(postCtx.previewCovers) ? (null
                                // <div
                                //     className={styles.uploadImageArea}
                                //     onClick={handleClickUploadImage}
                                // >
                                //     <div
                                //         className={styles.uploadImageIcon}
                                //     // style={{ backgroundImage: `url(${uploadImageIcon})` }}
                                //     />
                                //     <div
                                //         style={{ fontSize: "1rem", color: "#AFAFAF", marginTop: 10 }}
                                //     >
                                //         {t("Upload photo")}
                                //     </div>
                                // </div>
                            ) : (
                                <ImagePreviewPostContainer
                                    onAddImage={handleClickUploadImage}
                                    canMoreImage
                                    editable
                                    new
                                    handleCloseCover={handleCloseCover}
                                    // style={styles.CoverPreviewCreatePost}
                                    previewCovers={postCtx.previewCovers}
                                >

                                </ImagePreviewPostContainer>
                            )}

                            <Input
                                id="uploadImageEl"
                                ref={inputFileToUploadEl}
                                className={styles.inputfile}
                                type="file"
                                accept="image/*|video/*"
                                multiple
                                value={postCtx.fileValue}
                                onChange={(event) => {
                                    // onChangeSelectFile(event);
                                    handleUploadImage(event);
                                }}
                            />
                        </div>
                        <div className={styles.contentCustomize}>
                            <div className={styles.customTypesContainer}>
                                <div
                                    // className={styles.customType}
                                    className={
                                        postCtx.tag?.length !== 0
                                            ? styles.customTypeActive
                                            : styles.customType
                                    }
                                    onClick={() => {
                                        showModals();
                                        setCustomType(CustomTypes.TagFriend);
                                    }}
                                    style={{
                                        // backgroundImage: `url(${tagFriend})`,
                                        width: 25,
                                        backgroundSize: "cover",
                                        cursor: "pointer",
                                    }}
                                >
                                    <SvgTagFriend></SvgTagFriend>

                                </div>
                                <div
                                    className={styles.customType}
                                    // className={
                                    //     customType === CustomTypes.Style
                                    //         ? styles.customTypeActive
                                    //         : styles.customType
                                    // }
                                    // onClick={() => {
                                    //     setCustomType(CustomTypes.Style);
                                    // }}
                                    onClick={handleClickUploadImage}
                                    style={{
                                        // backgroundImage: `url(${uploadNewImage})`,
                                        width: 25,
                                        backgroundSize: "cover",
                                        cursor: "pointer",
                                        paddingRight: 30,
                                        borderRight: "inset",
                                    }}
                                >
                                    <SvgUploadImage></SvgUploadImage>
                                    <Input
                                        id="uploadImageEl"
                                        ref={inputFileToUploadEl}
                                        className={styles.inputfile}
                                        type="file"
                                        accept="image/*|video/*"
                                        multiple
                                        value={postCtx.fileValue}
                                        onChange={(event) => {
                                            // onChangeSelectFile(event);
                                            handleUploadImage(event);
                                        }}
                                    />

                                </div>
                                <Popover placement="bottom" content={Alignitem} trigger="click">
                                    <div
                                        // className={styles.customType}
                                        className={
                                            customType === CustomTypes.Align
                                                ? styles.customTypeActive
                                                : styles.customType
                                        }
                                        onClick={() => {
                                            setCustomType(CustomTypes.Align);
                                        }}
                                        style={{
                                            width: 25,
                                            backgroundSize: "cover",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <SvgAlignment></SvgAlignment>
                                    </div>
                                </Popover>
                                <Popover placement="bottom" content={styleFont} trigger="click">
                                    <div
                                        className={
                                            customType === CustomTypes.Style
                                                ? styles.customTypeActive
                                                : styles.customType
                                        }
                                        onClick={() => {
                                            setCustomType(CustomTypes.Style);
                                        }}
                                        style={{
                                            width: 25,
                                            backgroundSize: "cover",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <SvgFont></SvgFont>
                                    </div>
                                </Popover>


                                {_.isEmpty(postCtx.previewCovers) && (
                                    <Popover placement="bottom" content={backgroundCaption} trigger="click">
                                        <div
                                            // className={styles.customType}
                                            className={
                                                customType === CustomTypes.Background
                                                    ? styles.customTypeActive
                                                    : styles.customType
                                            }
                                            onClick={() => {
                                                setCustomType(CustomTypes.Background);
                                            }}
                                            style={{
                                                width: 25,
                                                backgroundSize: "cover",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <SvgBackground></SvgBackground>
                                        </div>
                                    </Popover>
                                )}

                            </div>

                            <div className={styles.customOptions}>
                                {/* {customType === CustomTypes.Style && (
                                <>
                                    <div
                                        className={styles.customItem}
                                        onClick={() => setCaptionStyle(CaptionStyleType.Regular)}
                                    >
                                        <SvgRegularIcon
                                            style={
                                                captionStyle === CaptionStyleType.Regular
                                                    ? { fill: "#000" }
                                                    : { fill: "#bebebe" }
                                            }
                                        />
                                    </div>
                                    <div
                                        className={styles.customItem}
                                        onClick={() => setCaptionStyle(CaptionStyleType.Bold)}
                                    >
                                        <SvgBoldIcon
                                            style={
                                                captionStyle === CaptionStyleType.Bold
                                                    ? { fill: "#000" }
                                                    : { fill: "#bebebe" }
                                            }
                                        />
                                    </div>
                                    <div
                                        className={styles.customItem}
                                        onClick={handleCaptionItalicChange}
                                    >
                                        <SvgItalicIcon
                                            style={
                                                captionItalic === CaptionStyleType.Italic
                                                    ? { fill: "#000" }
                                                    : { fill: "#bebebe" }
                                            }
                                        />
                                    </div>
                                    <div
                                        className={styles.customItem}
                                        onClick={handleCaptionUnderlineChange}
                                    >
                                        <SvgUnderlineIcon
                                            style={
                                                captionUnderline === CaptionStyleType.Underline
                                                    ? { fill: "#000" }
                                                    : { fill: "#bebebe" }
                                            }
                                        />
                                    </div>
                                </>
                            )} */}

                                {/* {customType === CustomTypes.Background && (
                                <>
                                    <div
                                        className={styles.customItem}
                                        onClick={() => {
                                            setCaptionBgColor("#fff");
                                        }}
                                    >
                                        <SvgEmptyIcon
                                            style={
                                                captionBgColor === "#fff"
                                                    ? { fill: "#000" }
                                                    : { fill: "#bebebe" }
                                            }
                                            width={"20px"}
                                        />
                                    </div>
                                    {CaptionBgList.map((bgColor: any) => {
                                        if (bgColor !== "#fff") {
                                            return (
                                                <div
                                                    key={bgColor}
                                                    className={
                                                        captionBgColor === bgColor
                                                            ? styles.colorItemActive
                                                            : styles.colorItem
                                                    }
                                                    style={{ backgroundColor: bgColor }}
                                                    onClick={() => {
                                                        setCaptionBgColor(bgColor);
                                                    }}
                                                ></div>
                                            );
                                        }
                                    })}
                                </>
                            )} */}
                            </div>
                        </div>

                        <div className={styles.categoryContainer}>
                            <label className={styles.createPostLabel}>{t("Category")}</label>
                            <div style={{ display: "flex", width: "100%" }}>
                                <ReactSelect
                                    // closeMenuOnSelect={false}
                                    placeholder={t("Select Category")}
                                    isMulti
                                    components={animatedComponents}
                                    options={categoryOption}
                                    captureMenuScroll={true}
                                    backspaceRemovesValue={false}
                                    styles={selectCustomStyleCategory}
                                    onChange={handleChangeCategory}
                                    onInputChange={handleInputCatChange}
                                    value={postCtx.category}
                                />
                                <div
                                    className={styles.addCatBtn}
                                    onClick={handleClickAddCategory}
                                >
                                    <PlusOutlined style={{ color: "#FFFFFF" }} />
                                </div>
                            </div>
                        </div>
                        {/* <div className={styles.categoryContainer}>
                        <label className={styles.createPostLabel}>{t("Post On")}</label>
                        <div
                            style={{ display: "flex", width: "100%", paddingRight: "35px" }}
                        >
                            <Select
                                placeholder={""}
                                options={group ? groupPrivacyOption : allPrivacyOption}
                                captureMenuScroll={true}
                                backspaceRemovesValue={false}
                                styles={selectCustomStyleCategory}
                                value={postCtx.privacyOption}
                                onChange={handleChangePrivacy}
                            />
                        </div>
                    </div> */}
                    </div>
                    <Divider style={{ backgroundColor: "#cccccc", margin: "35px 0px" }} />
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        {/*<button*/}
                        {/*    className={*/}
                        {/*        styles.btnPost*/}
                        {/*    }*/}
                        {/*    style={{*/}
                        {/*        // fontSize: "1.2rem",*/}
                        {/*        marginTop: "10px",*/}
                        {/*        // marginRight: "10px",*/}
                        {/*        // color: "#cccccc",*/}
                        {/*        // borderColor: "#cccccc",*/}
                        {/*        // backgroundColor: "#ffffff",*/}
                        {/*        // border: "2px solid",*/}
                        {/*    }}*/}
                        {/*// disabled={*/}
                        {/*//   postCtx.isDisablePostBtn || postCtx.confirmLoading || isPosting*/}
                        {/*// }*/}
                        {/*>*/}
                        {/*    <div onClick={handleSaveDraft}>*/}
                        {/*        {t("Save Draft")}*/}
                        {/*    </div>*/}
                        {/*</button>*/}
                        <CenterButton
                            ghost
                            small
                            disabled={postCtx.isDisablePostBtn || postCtx.confirmLoading || isPosting}
                            onClick={handleSaveDraft}
                            style={{
                                // fontSize: "1.2rem",
                                marginTop: "10px",
                                marginRight: "10px",
                                // color: "#cccccc",
                                // borderColor: "#cccccc",
                                // backgroundColor: "#ffffff",
                                // border: "2px solid",
                            }}
                        >
                            {t("Save Draft")}
                        </CenterButton>
                        <CenterButton
                            // className={
                            //     postCtx.isDisablePostBtn ? styles.btnPostDisabled : styles.btnPost
                            // }
                            small
                            style={{
                                // fontSize: "1.2rem",
                                marginTop: "10px",
                            }}
                            loading={postCtx.confirmLoading}
                            disabled={
                                postCtx.isDisablePostBtn
                            }
                            onClick={handlePost}
                        // disabled={
                        //   postCtx.isDisablePostBtn || postCtx.confirmLoading || isPosting
                        // }
                        >
                            {t("Post")}
                        </CenterButton>

                    </div>

                </div>
            </Modal>

            <CenterConfirmModal
                visible={postCtx.showModalCheckCancel}
                onCancel={hideModalCheckCancel}
                onConfirm={okModalCheckCancel}
                text={postCtx.isEditPost ? `${t("Are you sure you want to cancel edit post")}?` : `${t("Are you sure you want to cancel create post")}?`}
                confirmText={t("OK")}
                cancelText={t("Cancel")}
            />
        </Fragment>
    );
};

export default CreatePostModal;
